"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCompetitionEventTimeZoneRulesTransitionRulesInner = instanceOfCompetitionEventTimeZoneRulesTransitionRulesInner;
exports.CompetitionEventTimeZoneRulesTransitionRulesInnerFromJSON = CompetitionEventTimeZoneRulesTransitionRulesInnerFromJSON;
exports.CompetitionEventTimeZoneRulesTransitionRulesInnerFromJSONTyped = CompetitionEventTimeZoneRulesTransitionRulesInnerFromJSONTyped;
exports.CompetitionEventTimeZoneRulesTransitionRulesInnerToJSON = CompetitionEventTimeZoneRulesTransitionRulesInnerToJSON;
exports.CompetitionEventTimeZoneRulesTransitionRulesInnerToJSONTyped = CompetitionEventTimeZoneRulesTransitionRulesInnerToJSONTyped;
var CompetitionEventTimeZoneRulesTransitionsInnerOffsetBefore_1 = require("./CompetitionEventTimeZoneRulesTransitionsInnerOffsetBefore");
var DayOfWeek_1 = require("./DayOfWeek");
var Month_1 = require("./Month");
var LocalTime_1 = require("./LocalTime");
var TimeDefinition_1 = require("./TimeDefinition");
/**
 * Check if a given object implements the CompetitionEventTimeZoneRulesTransitionRulesInner interface.
 */
function instanceOfCompetitionEventTimeZoneRulesTransitionRulesInner(value) {
    return true;
}
function CompetitionEventTimeZoneRulesTransitionRulesInnerFromJSON(json) {
    return CompetitionEventTimeZoneRulesTransitionRulesInnerFromJSONTyped(json, false);
}
function CompetitionEventTimeZoneRulesTransitionRulesInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'month': json['month'] == null ? undefined : (0, Month_1.MonthFromJSON)(json['month']),
        'timeDefinition': json['timeDefinition'] == null ? undefined : (0, TimeDefinition_1.TimeDefinitionFromJSON)(json['timeDefinition']),
        'standardOffset': json['standardOffset'] == null ? undefined : (0, CompetitionEventTimeZoneRulesTransitionsInnerOffsetBefore_1.CompetitionEventTimeZoneRulesTransitionsInnerOffsetBeforeFromJSON)(json['standardOffset']),
        'offsetBefore': json['offsetBefore'] == null ? undefined : (0, CompetitionEventTimeZoneRulesTransitionsInnerOffsetBefore_1.CompetitionEventTimeZoneRulesTransitionsInnerOffsetBeforeFromJSON)(json['offsetBefore']),
        'offsetAfter': json['offsetAfter'] == null ? undefined : (0, CompetitionEventTimeZoneRulesTransitionsInnerOffsetBefore_1.CompetitionEventTimeZoneRulesTransitionsInnerOffsetBeforeFromJSON)(json['offsetAfter']),
        'dayOfWeek': json['dayOfWeek'] == null ? undefined : (0, DayOfWeek_1.DayOfWeekFromJSON)(json['dayOfWeek']),
        'dayOfMonthIndicator': json['dayOfMonthIndicator'] == null ? undefined : json['dayOfMonthIndicator'],
        'localTime': json['localTime'] == null ? undefined : (0, LocalTime_1.LocalTimeFromJSON)(json['localTime']),
        'midnightEndOfDay': json['midnightEndOfDay'] == null ? undefined : json['midnightEndOfDay'],
    };
}
function CompetitionEventTimeZoneRulesTransitionRulesInnerToJSON(json) {
    return CompetitionEventTimeZoneRulesTransitionRulesInnerToJSONTyped(json, false);
}
function CompetitionEventTimeZoneRulesTransitionRulesInnerToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'month': (0, Month_1.MonthToJSON)(value['month']),
        'timeDefinition': (0, TimeDefinition_1.TimeDefinitionToJSON)(value['timeDefinition']),
        'standardOffset': (0, CompetitionEventTimeZoneRulesTransitionsInnerOffsetBefore_1.CompetitionEventTimeZoneRulesTransitionsInnerOffsetBeforeToJSON)(value['standardOffset']),
        'offsetBefore': (0, CompetitionEventTimeZoneRulesTransitionsInnerOffsetBefore_1.CompetitionEventTimeZoneRulesTransitionsInnerOffsetBeforeToJSON)(value['offsetBefore']),
        'offsetAfter': (0, CompetitionEventTimeZoneRulesTransitionsInnerOffsetBefore_1.CompetitionEventTimeZoneRulesTransitionsInnerOffsetBeforeToJSON)(value['offsetAfter']),
        'dayOfWeek': (0, DayOfWeek_1.DayOfWeekToJSON)(value['dayOfWeek']),
        'dayOfMonthIndicator': value['dayOfMonthIndicator'],
        'localTime': (0, LocalTime_1.LocalTimeToJSON)(value['localTime']),
        'midnightEndOfDay': value['midnightEndOfDay'],
    };
}
